import { FeeBasedContractSuccessResponse } from '@genial/services';
import { Utils } from '@genial/utils';

import {
  FixedFeeTermAcceptanceData,
  FixedFeeTermActionType,
} from '../../pages/FixedFeeTermAcceptanceLink/utils/types';
import { statusTermBeingRevoked } from '../fixedFee/constants';

const getAdvisorName = (firstName?: string | null, lastName?: string | null): string => {
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

  return fullName || 'Assessor não informado';
};

const formatDate = (date?: Date | null, emptyLabel = '--'): string => {
  if (!date) {
    return emptyLabel;
  }

  return Utils.Mask.DateFormat(date, 'dd/MM/yyyy');
};

const formatRate = (feePercentage?: number): string => {
  if (feePercentage === undefined || feePercentage === null) {
    return '--';
  }

  return `${Utils.Mask.Percentage(feePercentage)} ao ano`;
};

export const normalizeFixedFeePublicTerm = (
  response: FeeBasedContractSuccessResponse
): FixedFeeTermAcceptanceData => {
  const agreement = response.data;
  const isRevocationFlow = statusTermBeingRevoked.includes(agreement.statusId);

  const actionType: FixedFeeTermActionType = isRevocationFlow ? 'revocation' : 'acceptance';

  return {
    termId: agreement.feeBasedContractId.toString(),
    actionType,
    advisorName: getAdvisorName(
      agreement.user?.resourceFirstName,
      agreement.user?.resourceLastName
    ),
    expirationDate: formatDate(agreement.offerExpirationDate, 'Sem data'),
    feeRate: formatRate(agreement.feePercentage),
    startDate: formatDate(agreement.startDate, '--'),
    terminationDate: formatDate(agreement.terminationDate, '--'),
    termsFilename: agreement.fileName || '',
    termsLinkUrl: agreement.fileUrl || undefined,
  };
};
